<template>
  <!-- Üç yerde kullanılan ortak bildirim satırı (Tüm Bildirimler paneli, zil dropdown'u,
       SparqonBildirimDialog) - bkz. Dokumanlar/Bildirim/TUM-BILDIRIMLER-PANEL-PLANI.md §2.3.
       Okuma/yönlendirme/pencere kapatma kararı burada YOK, çağırana "tikla" ile bırakılır. -->
  <div
    class="flex items-start gap-3"
    :class="[
      sikisik ? 'px-3 py-2' : 'p-3',
      rotali ? 'cursor-pointer' : 'cursor-default',
      rotali || !notif.read ? 'hover:bg-gray-50 dark:hover:bg-gray-800' : '',
    ]"
    @click="$emit('tikla', notif)"
  >
    <div class="w-[8px] flex-none flex justify-center pt-[6px]">
      <span
        v-if="!notif.read"
        class="w-[6px] h-[6px] rounded-full dolgu-olumlu"
      ></span>
    </div>

    <!-- ⚠️ w-8/w-9 DEĞİL: kök font 14px olduğu için rem sınıfları küçük kalır (bkz. plan §2.3). -->
    <div
      class="w-[32px] h-[32px] flex-none rounded-full flex items-center justify-center"
      :class="gorsel.sinif"
    >
      <i :class="gorsel.icon" style="font-size: 14px"></i>
    </div>

    <div class="flex-1 min-w-0">
      <div class="flex items-center justify-between gap-2">
        <div
          class="text-sm"
          :class="[
            notif.read ? 'font-normal text-gray-700 dark:text-gray-300' : 'font-semibold text-gray-900 dark:text-gray-100',
            sikisik ? 'truncate' : '',
          ]"
        >{{ baslik }}</div>
        <div
          v-tooltip.left="tamTarih"
          class="text-xs text-gray-400 dark:text-gray-500 whitespace-nowrap flex-shrink-0"
        >{{ notif.time }}</div>
      </div>
      <div
        class="text-sm text-gray-600 dark:text-gray-400 mt-0.5"
        :class="sikisik ? 'truncate' : ''"
      >{{ notif.content }}</div>
    </div>
  </div>
</template>

<script>
import { bildirimGorsel, bildirimRotasi, bildirimTamTarih } from "@/services/bildirimYonlendirme.js";
import { bildirimBaslikEtiket } from "@/utils/teklifEtiket";

export default {
  name: "BildirimSatiri",
  props: {
    notif: { type: Object, required: true },
    // Dropdown gibi dar kaplarda başlık/içerik tek satıra kırpılır (bkz. plan §2.3).
    sikisik: { type: Boolean, default: false },
  },
  emits: ["tikla"],
  computed: {
    // YB-11(r): teklif karar kodları (DuzeltmeIste, RevizyonTalep…) okunur metne çevrilir
    baslik() {
      return bildirimBaslikEtiket(this.notif.title);
    },
    gorsel() {
      return bildirimGorsel(this.notif);
    },
    rotali() {
      return !!bildirimRotasi(this.notif);
    },
    tamTarih() {
      return bildirimTamTarih(this.notif.tarih);
    },
  },
};
</script>
